import { SITE } from './SEO';

// Builder functions returning fresh schema objects.
// (Functions—not exported constants—are used so the visual-edits Babel plugin
//  does not attempt cross-file identifier tracing on nested JSON-LD graphs.)

const ADDRESS = {
  '@type': 'PostalAddress',
  streetAddress: '2nd Floor, Darshan Orchid Complex, MSK Mill Road, opposite Sangameshwar Hospital, Vidya Nagar',
  addressLocality: 'Kalaburagi',
  addressRegion: 'Karnataka',
  postalCode: '585103',
  addressCountry: 'IN',
};

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': SITE.url + '#organization',
    name: 'Genius Academy',
    legalName: 'Genius Academy — Technical and Computer Training Institute',
    url: SITE.url,
    logo: SITE.logo,
    image: SITE.logo,
    telephone: ['+91-9164998997', '+91-9980147616'],
    email: 'info@geniusacademyklbg.com',
    address: ADDRESS,
    areaServed: [
      { '@type': 'City', name: 'Kalaburagi' },
      { '@type': 'City', name: 'Gulbarga' },
    ],
    sameAs: ['https://maps.app.goo.gl/cXXM4Lyg81THD5xf7'],
  };
}

export function getEducationalOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': ['EducationalOrganization', 'LocalBusiness'],
    '@id': SITE.url + '#educationalorganization',
    name: 'Genius Academy',
    alternateName: 'Genius Academy Computer Training Institute',
    description:
      'Genius Academy is a Technical and Computer Training Institute in Kalaburagi (Gulbarga) offering personalised 1:1 accountability, hands-on training, and courses in MS Office, Tally with GST, Python, Web Development, Photoshop, CorelDRAW, Basic Computer, Typing and Computer Hardware.',
    url: SITE.url,
    logo: SITE.logo,
    image: SITE.logo,
    telephone: '+91-9164998997',
    priceRange: '\u20B9\u20B9',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        opens: '08:00',
        closes: '20:00',
      },
    ],
    address: ADDRESS,
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 17.3251499,
      longitude: 76.8197221,
    },
    hasMap: 'https://maps.app.goo.gl/cXXM4Lyg81THD5xf7',
    areaServed: [
      { '@type': 'City', name: 'Kalaburagi' },
      { '@type': 'City', name: 'Gulbarga' },
      { '@type': 'AdministrativeArea', name: 'Karnataka' },
    ],
    sameAs: ['https://maps.app.goo.gl/cXXM4Lyg81THD5xf7'],
  };
}

export function getWebsiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': SITE.url + '#website',
    name: 'Genius Academy',
    url: SITE.url,
    inLanguage: 'en-IN',
    publisher: { '@id': SITE.url + '#organization' },
    potentialAction: {
      '@type': 'SearchAction',
      target: SITE.url + '/courses?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getFaqItems() {
  return [
    {
      q: 'Where is Genius Academy located in Kalaburagi (Gulbarga)?',
      a: 'Genius Academy is located at 2nd Floor, Darshan Orchid Complex, MSK Mill Road, opposite Sangameshwar Hospital, Vidya Nagar, Kalaburagi (Gulbarga), Karnataka 585103.',
    },
    {
      q: 'What computer courses does Genius Academy offer?',
      a: 'We offer MS Office, Tally with GST, Basic Computer, Typing, Python, Web Development, Photoshop, CorelDRAW, and Computer Hardware — with 1:1 accountability and hands-on practice.',
    },
    {
      q: 'What are the timings of the computer institute?',
      a: 'Genius Academy is open Monday to Saturday from 8:00 AM to 8:00 PM. We are closed on Sundays.',
    },
    {
      q: 'Do you provide placement assistance after the course?',
      a: 'Yes. We provide placement assistance, career guidance, resume building and interview preparation for eligible students. Final selection depends on the student\u2019s skills, interview performance and available opportunities.',
    },
    {
      q: 'How can I book a free demo class at Genius Academy?',
      a: 'You can book a free demo class by calling 9164998997 / 9980147616, sending a WhatsApp message, or filling the enquiry form on our Contact page.',
    },
    {
      q: 'Do you issue certificates after course completion?',
      a: 'Yes. Every student receives a Genius Academy certificate after completing the syllabus. The certificate can be verified online through our Verify Certificate page.',
    },
  ];
}

export function getFaqSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: getFaqItems().map(function (f) {
      return {
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      };
    }),
  };
}
